import { DependencyList } from 'react';
import { DialogProps, useSimpleDialog } from '../../hooks/useDialog';
import { DialogBox } from '../atomic/dialog';
import { FilesAPI } from '../../APIs/filesApi';
import { getAsync, useGet } from '../../hooks/useApi';

export type EmptyTrashDialogProps = DialogProps<{ folderId: string }, void>;
export const useEmptyTrashDialog = (
    { onTrash }: { onTrash: () => void },
    deps: DependencyList
) =>
    useSimpleDialog(
        EmptyTrashDialog,
        (options) => ({
            options,
            async onCommit() {
                let offset = 0;
                while (1) {
                    try {
                        const result = await getAsync(
                            FilesAPI._items({
                                parentFolderId: options.folderId,
                                folder: true,
                                file: false,
                                frame: false,
                                idsOnly: true,
                                limit: 10,
                                offset,
                            })
                        );
                        if (result.data.length) {
                            const deleted = await FilesAPI.delete(
                                undefined,
                                result.data
                            );
                        }
                        if (
                            !result.pagination ||
                            result.pagination?.hasNextPage === false
                        ) {
                            break;
                        }
                        offset = result.pagination.nextOffset;
                    } catch (error) {
                        throw new Error('削除に失敗しました');
                    }
                }
                onTrash();
            },
            onError: (error) => error.message || '削除に失敗しました',
        }),
        deps
    );

export const EmptyTrashDialog = (props: EmptyTrashDialogProps) => {
    const { ...rest } = props;

    return (
        <DialogBox className="empty-trash" okText="削除" {...rest}>
            <div className="inner">
                <h3 className="msg">
                    <i className="fa-solid fa-triangle-exclamation" />
                    ゴミ箱を空にします
                </h3>
            </div>
        </DialogBox>
    );
};
